module.exports = __webpack_public_path__ + "static/media/study 220210.f87044ae.png";